import React from "react";
import SigninWrapper from "components/Authentication/Views/SignInView";
import SignInForm from "components/Authentication/Form/SignIn/SignInForm";
import View from "components/Authentication/Views/View";
const logoImages = [
  require("assets/images/login-signup/MCC-logo.png"),
  require("assets/images/login-signup/My-Physio-My-Health-logox2.png"),
  require("assets/images/login-signup/luxfeel.png"),
  require("assets/images/login-signup/moimoilogo.gif"),
  require("assets/images/login-signup/dog-nation.jpg"),
  require("assets/images/login-signup/upcoach.png"),
  require("assets/images/login-signup/sunboost.png")
];

function SignIn() {
  return (
    <View
      title="Get Started Instantly - No Credit Card Required."
      subtitle="Launch your SMS campaigns faster than ever. Whether you're reaching out to customers, sending updates, or running promotions, Guni SMS makes it simple and efficient. Start sending messages in just a few clicks."
      heroImage={require("assets/images/login-signup/split.png")}
      logoImages={logoImages}
      showSplit
    >
      <SignInForm />
    </View>
  );
}

export default SignIn;
